import BalanceAccess from './container'

export default BalanceAccess
